import doc                  from 'decorators/doc';
import model                from 'decorators/model';
import SalesPrivateApiModel from 'modelx/models/abstracts/SalesPrivateApiModel';

@model.staticLabel('ItemDisplayMode')
@model.urnResource('item_display_mode')
@doc.path('/item_display_modes/{?id}')
export default class ItemDisplayModeModel extends SalesPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': SalesItemDisplayModeReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare reference: SalesItemDisplayModeReference;
}